export default __webpack_public_path__ + "static/media/pencil-dark-winter.9441e6c5.png";